import * as React from 'react';
import { connect } from 'react-redux';
import './LoginTab.scss';
import { Actions } from '@src/constants/Constants';
import { RootState } from '@src/reducers';
import LoginForm from '@src/containers/login-overlay/login-tab/login-form/LoginForm';

interface IReduxState {}

interface IReduxActions {
    initLoading: () => void;
}

type IAllProps = IReduxState & IReduxActions;

class LoginTab extends React.Component<IAllProps, {}> {
    state = {
        password: '',
        username: '',
    };

    render() {
        const {} = this.props;
        return (
            <div className="LoginTab-wrap">
                <LoginForm />
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    return {};
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        initLoading: () =>
            dispatch({ type: Actions.IS_LOADING, payload: true }),
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(LoginTab);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login-overlay/login-tab/LoginTab.tsx